class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this)); 
    this.setHeaderCartIconAccessibility();
  }

  setHeaderStickyForDrawer(isOpen) {
    if (!window.theme || !window.theme.enableFlyToCart) return;
    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader && typeof stickyHeader.pinForCartDrawer === 'function') {
      isOpen ? stickyHeader.pinForCartDrawer() : stickyHeader.unpinForCartDrawer();
      return;
    }
    const header = document.querySelector('.section-header');
    if (!header) return;
    if (isOpen) {
      if (header.dataset.cartDrawerPinned) return;
      header.dataset.cartDrawerPinned = 'true';
      header.dataset.cartDrawerHadSticky = header.classList.contains('shopify-section-header-sticky') ? '1' : '0';
      header.dataset.cartDrawerHadHidden = header.classList.contains('shopify-section-header-hidden') ? '1' : '0';
      header.classList.add('shopify-section-header-sticky', 'cart-drawer-pinned');
      header.classList.remove('shopify-section-header-hidden', 'animate');
    } else if (header.dataset.cartDrawerPinned) {
      header.classList.remove('cart-drawer-pinned');
      delete header.dataset.cartDrawerPinned;
      delete header.dataset.cartDrawerHadSticky;
      delete header.dataset.cartDrawerHadHidden;
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }


  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});
    setTimeout(() => {if(this.querySelector('subcart-drawer')) this.querySelector('subcart-drawer').openSubDrawer()});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    this.setHeaderStickyForDrawer(true);
  }

  close() {
    if(this.querySelector('subcart-drawer')) this.querySelector('subcart-drawer').closeSubDrawer();
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.setHeaderStickyForDrawer(false);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, options = {}) {
    const openDrawer = options.openDrawer !== false;

    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (openDrawer) this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class SubCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.querySelector('#sub_d_close').addEventListener('click', this.closeSubDrawer.bind(this));
  }

   closeSubDrawer(){
    this.classList.remove('active')
  }

  openSubDrawer(){
    this.classList.add('animate', 'active')
  }
}

customElements.define('subcart-drawer', SubCartDrawer);